
import jaMessages from '../locales/ja-JA';

const JaLang = {
    messages: {
        ...jaMessages
    },
    locale: 'ja-JA',
  
};
export default JaLang;